const pad = (num, size) => {
  let string = num.toString()
  while (string.length < size) string = `0${string}`
  return string
}

export default pad
